import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { ICodename, IDataDetailAnalysis, IErrorAnalysis } from "commons/interfaces";



export const CardSeverityOfInjury = ({
    mode,
    dataOptions,
    dataAnalysis,
    errorAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    errorAnalysis: IErrorAnalysis;
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        affectedToPatient: ICodename[];
        affectedToPatientCause: ICodename[];
        affectedToOrganization: ICodename[];
        environmentPatient: ICodename[];
        managementPatient: ICodename[];
        equipment: ICodename[];
        medical: ICodename[];
        surgery: ICodename[];
        crime: ICodename[];
    };
}) => {

    const renderAffectedToPatientCauseDetail = (code?: string) => {
        switch (code) {
            case "managementPatient":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.SPECIFICALLY}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.managementPatient || []}
                        defaultValue={dataAnalysis?.affectedToPatientCauseDetail}
                        errorMessage={errorAnalysis?.affectedToPatientCauseDetail}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatientCauseDetail", value)
                        }}
                    />
                );
            case "equipment":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.equipment || []}
                        label={Strings.ANALYSIS.SPECIFICALLY}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.affectedToPatientCauseDetail}
                        errorMessage={errorAnalysis?.affectedToPatientCauseDetail}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatientCauseDetail", value)
                        }}
                    />
                );
            case "environmentPatient":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        label={Strings.ANALYSIS.SPECIFICALLY}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        data={dataOptions.environmentPatient || []}
                        defaultValue={dataAnalysis?.affectedToPatientCauseDetail}
                        errorMessage={errorAnalysis?.affectedToPatientCauseDetail}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatientCauseDetail", value)
                        }}
                    />
                );
            case "medical":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.medical || []}
                        label={Strings.ANALYSIS.SPECIFICALLY}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.affectedToPatientCauseDetail}
                        errorMessage={errorAnalysis?.affectedToPatientCauseDetail}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatientCauseDetail", value)
                        }}
                    />
                );
            case "surgery":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.surgery || []}
                        label={Strings.ANALYSIS.SPECIFICALLY}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.affectedToPatientCauseDetail}
                        errorMessage={errorAnalysis?.affectedToPatientCauseDetail}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatientCauseDetail", value)
                        }}
                    />
                );
            case "crime":
                return (
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.crime || []}
                        label={Strings.ANALYSIS.SPECIFICALLY}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={dataAnalysis?.affectedToPatientCauseDetail}
                        errorMessage={errorAnalysis?.affectedToPatientCauseDetail}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatientCauseDetail", value)
                        }}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.SEVERITY_OFINJURY}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.affectedToPatient}
                        label={Strings.ANALYSIS.AFFECTED_TO_PATIENT}
                        defaultValue={dataAnalysis?.affectedToPatient}
                        errorMessage={errorAnalysis?.affectedToPatient}
                        placeholder={Strings.ANALYSIS.AFFECTED_TO_PATIENT}
                        onChange={(value) => {
                            handleChangeValue("affectedToPatient", value);
                        }}
                    />
                </Grid>
                {
                    dataAnalysis?.affectedToPatient &&
                    ["6", "7", "8"].includes(dataAnalysis?.affectedToPatient) &&
                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            mode={mode}
                            variant={"outlined"}
                            data={dataOptions.affectedToPatientCause}
                            label={Strings.ANALYSIS.AFFECTED_TO_PATIENT_CAUSE}
                            defaultValue={dataAnalysis?.affectedToPatientCause}
                            errorMessage={errorAnalysis?.affectedToPatientCause}
                            placeholder={Strings.ANALYSIS.SELECT_AFFECTED_TO_PATIENT_CAUSE}
                            onChange={(value) => {
                                handleChangeValue("affectedToPatientCause", value);
                            }}
                        />
                    </Grid>
                }
                {
                    dataAnalysis?.affectedToPatient &&
                    ["6", "7", "8"].includes(dataAnalysis?.affectedToPatient) &&
                    <Grid item xs={12} sm={6}>
                        {renderAffectedToPatientCauseDetail(dataAnalysis?.affectedToPatientCause)}
                    </Grid>
                }
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        variant={"outlined"}
                        data={dataOptions.affectedToOrganization}
                        label={Strings.ANALYSIS.AFFECTED_TO_ORGANIZATION}
                        defaultValue={dataAnalysis?.affectedToOrganization}
                        errorMessage={errorAnalysis?.affectedToOrganization}
                        placeholder={Strings.ANALYSIS.SELECT_AFFECTED_TO_ORGANIZATION}
                        onChange={(value) => {
                            handleChangeValue("affectedToOrganization", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardSeverityOfInjury;
